import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { LeaderboardRow } from "../../models/game.models";
import { ProblemCategory } from "../../models/problem.models";
import { GameService } from "../../services/game.service";
import { ProblemService } from "../../services/problem.service";

type LeaderboardScope = "global" | "weekly" | "topic";

@Component({
  selector: "app-leaderboard",
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: "./leaderboard.component.html",
  styleUrl: "./leaderboard.component.css"
})
export class LeaderboardComponent implements OnInit {
  rows: LeaderboardRow[] = [];
  categories: ProblemCategory[] = [];
  loading = true;
  error = "";

  scope: LeaderboardScope = "global";
  selectedTopic = "";

  constructor(
    private readonly gameService: GameService,
    private readonly problemService: ProblemService
  ) {}

  ngOnInit(): void {
    this.problemService.getCategories().subscribe({
      next: (categories) => {
        this.categories = categories;
        if (categories.length > 0) {
          this.selectedTopic = categories[0].topic;
        }
      }
    });
    this.loadLeaderboard();
  }

  setScope(scope: LeaderboardScope) {
    this.scope = scope;
    this.loadLeaderboard();
  }

  onTopicChange(topic: string) {
    this.selectedTopic = topic;
    if (this.scope === "topic") {
      this.loadLeaderboard();
    }
  }

  trackByCategory(_: number, item: ProblemCategory) {
    return item.topic;
  }

  trackByRow(_: number, row: LeaderboardRow) {
    return row.id;
  }

  private loadLeaderboard() {
    this.loading = true;
    this.error = "";
    this.gameService.getLeaderboard(50, this.scope, this.scope === "topic" ? this.selectedTopic : undefined).subscribe({
      next: (rows) => {
        this.rows = rows;
        this.loading = false;
      },
      error: (error) => {
        this.error = error?.error?.message || "Failed to load leaderboard";
        this.loading = false;
      }
    });
  }
}
